import { TextField } from "@goodgamestudios/createjs-utilities";

export class CardRankingVO {
    public rankingId: number = NaN;
    public tf_label: TextField;
    public yPos: number = NaN;

    constructor(rankingId: number = 0, tf_label: TextField = null, yPos: number = 0) {
        this.rankingId = rankingId;
        this.tf_label = tf_label;
        this.yPos = yPos;
    }
}
